/**
 * Supabase client configuration
 * 
 * Note: This is a shared configuration file. Each package (web/extension) 
 * should provide its own environment variables or configuration.
 */

import { createClient, SupabaseClient, type SupabaseClientOptions } from '@supabase/supabase-js'

/**
 * Create Supabase client with provided credentials
 * This function should be called with environment-specific values
 */
export const createSupabaseClient = (
  supabaseUrl: string,
  supabaseAnonKey: string,
  clientOptions?: SupabaseClientOptions<'public'>,
): SupabaseClient => {
  if (!supabaseUrl || !supabaseAnonKey) {
    throw new Error('Missing Supabase environment variables')
  }

  return createClient(supabaseUrl, supabaseAnonKey, {
    ...clientOptions,
    auth: {
      flowType: 'pkce',
      detectSessionInUrl: false,
      persistSession: true,
      autoRefreshToken: true,
      ...clientOptions?.auth,
    },
  })
}


